import React from 'react';
import css from './Modal.module.scss';
import Button from '../../../../../components/UI/Button';

export default function Modal({
  header,
  subheader,
  option,
  optionAction,
  secondaryOption,
  secondaryOptionAction
}) {
  return (
    <div className={css.modalBackground}>
      <div className={css.modal}>
        <p>{header}</p>
        <p>{subheader}</p>
        <div className={css.options}>
          <Button data-testid="option" text={option} onClick={optionAction} />
          {secondaryOption && (
            <Button
              data-testid="secondary-option"
              text={secondaryOption}
              onClick={secondaryOptionAction}
            />
          )}
        </div>
      </div>
    </div>
  );
}
